import {B2BScreenParam} from '../types';
import {B2BScreens} from './types';
import {HomeScreens} from '@buncha/home/navigation/types';
import {NavAction} from '@buncha/config/navigation/type';
import {navigation} from '../../config/navigation';

export default {
  [B2BScreens.B2BCheckout]: (
    params?: B2BScreenParam,
    navigateAction?: NavAction,
  ) => {
    navigation.navigate(
      HomeScreens.B2B,
      {
        screen: B2BScreens.B2BCheckout,
        params,
      },
      navigateAction,
    );
  },
  [B2BScreens.B2BBarcode]: (params?: any, navigateAction?: NavAction) => {
    navigation.navigate(
      HomeScreens.B2B,
      {
        screen: B2BScreens.B2BBarcode,
        params,
      },
      navigateAction,
    );
  },
  [B2BScreens.B2BOrderInfo]: (params?: any, navigateAction?: NavAction) => {
    navigation.navigate(
      HomeScreens.B2B,
      {
        screen: B2BScreens.B2BOrderInfo,
        params,
      },
      navigateAction,
    );
  },
};
